<template>
  <div class="choose">
    <ul>
      <li v-for="(item, index) of list" :key="index" @click="areaCodeClick(item)">
        <p>{{item.country}}</p>
        <b>+{{item.code}}</b>
      </li>
    </ul>
  </div>
</template>

<script>
const areaCodeList = require('../../assets/common/js/areaCode')
export default {
  name: 'boundChooseCountry',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.list = areaCodeList
  },
  methods: {
    areaCodeClick: function (items) {
      this.$router.replace({
        path: '/bound',
        query: {
          'area_code': items.code
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.choose {
  background: #fff;
  ul {
    li {
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      padding: 0.12rem 0;
      margin: 0 0.11rem;
      border-bottom: 1px solid #EFEFEF;
      p {
        font-size:0.15rem;
        font-weight:400;
        color:rgba(41,41,41,1);
        line-height:0.21rem;
      }
      b {
        display: block;
        font-size:0.15rem;
        font-weight:600;
        color:rgba(74,144,226,1);
        line-height:0.21rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/phone/boundChooseCountry.vue